import { request } from "../util/request"
import { top_shows_api_v1_posts_path } from "../routes"

export interface TopShow {
  id: number
  event_playlist_id: number | null
  title: string
  url: string
  nada_path: string
  image_url: string | null
  date: string
  venue_name: string | null
  venue_city: string | null
  band_name: string
  band_url: string | null
  rsvp_count: number
}

export interface TopShowsResponse {
  shows: TopShow[]
}

export async function getTopShows(
  scene: string,
  limit = 20,
): Promise<TopShowsResponse> {
  return request({
    queryKey: [
      "topShows",
      {
        path: top_shows_api_v1_posts_path({ scene, limit }),
        options: { method: "GET" },
      },
    ],
  })
}
